var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white text-capitalize primaryDark--text d-inline px-2 py-1 active-chip title font-weight-light"},[_vm._v(_vm._s(_vm.active))])}
var staticRenderFns = []

export { render, staticRenderFns }